export default __webpack_public_path__ + "static/media/recoverPassword-banner.dfd89d4c.png";